/* The Dragonfly Library page. Rebuilt 2026-09-18, reworked the same day for usability.

   Two independent jobs:
   1. Reads ?b=<booklet-tag> from the URL and folds it into the sign-up form's hidden
      contact[tags] field, so each booklet's own QR code records which booklet brought the
      visitor in. No b present: the tag stays "library".
   2. Renders the shelf in two bands (window.DFL_DATA, from assets/dragonfly-library-data.js):
      "Available now" as full cards, "More on the way" as compact rows grouped by theme, and
      drives the search box, the title/theme search-mode toggle, the theme chips (prioritised:
      themes with something buyable today show first, the rest sit behind "More themes") and
      the "only show what I can get today" filter. All client-side, no reload.
*/
(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    tagSignupForm();
    initShelf();
  });

  // --- 1. Per-booklet sign-up tag ---------------------------------------------------------
  function tagSignupForm() {
    var params = new URLSearchParams(window.location.search);
    var b = params.get('b');
    if (!b) return;
    var safe = b.toLowerCase().replace(/[^a-z0-9-]/g, '');
    if (!safe) return;
    document.querySelectorAll('[data-library-tag-field]').forEach(function (field) {
      field.value = 'library,booklet-' + safe;
    });
  }

  // --- 2. The shelf: two bands, search + filter -------------------------------------------
  function initShelf() {
    var availableGrid = document.getElementById('dfl-available-grid');
    if (!availableGrid || !window.DFL_DATA) return;

    var books = window.DFL_DATA;
    var subSeriesOrder = window.DFL_SUBSERIES_ORDER || [];
    var freeLabel = 'Free';
    var comingLabel = 'Coming';
    // Page-scoped only: set via data-dfl-suppress-free on the shelf section (Books collection
    // page template). Does not touch window.DFL_DATA, so every other page that renders this
    // same shelf (e.g. /pages/dragonfly-library) keeps showing Water Breaks the Rules as free.
    var shelfSectionEl = document.getElementById('dfl-shelf');
    var suppressFreeFraming = !!(shelfSectionEl && shelfSectionEl.getAttribute('data-dfl-suppress-free') === 'true');

    // The free booklet leads the "Ready to get today" band, always: it is the way in for a
    // stranger with no cost of entry, and the hero copy right above promises it by name. The
    // next four follow the handover's own best-first order. Anything else buyable today
    // (including a later addition, e.g. Silver Copper Gold once it clears compliance) keeps
    // its natural roadmap order after that - stable, data-driven, never scrambled by a filter:
    // this sort runs once at build time, filtering afterwards only toggles [hidden].
    var LEAD_ORDER = ['water', 'sound', 'chester', 'calendar', 'russell'];
    var availableBooks = books
      .filter(function (b) { return b.state === 'available' || b.state === 'free'; })
      .slice()
      .sort(function (a, b) {
        var ai = LEAD_ORDER.indexOf(a.key); if (ai === -1) ai = LEAD_ORDER.length;
        var bi = LEAD_ORDER.indexOf(b.key); if (bi === -1) bi = LEAD_ORDER.length;
        return ai - bi; // stable: ties (everything past the named five) keep roadmap order
      });
    var comingBooks = books.filter(function (b) { return b.state === 'coming'; });

    var searchInput = document.getElementById('dfl-search-input');
    var clearBtn = document.getElementById('dfl-search-clear');
    var countEl = document.getElementById('dfl-count');
    var primaryThemesEl = document.getElementById('dfl-themes-primary');
    var secondaryThemesEl = document.getElementById('dfl-themes-secondary');
    var availableToggle = document.getElementById('dfl-available-toggle');
    var emptyEl = document.getElementById('dfl-empty');
    var emptyQueryEl = document.getElementById('dfl-empty-query');
    var emptyClearBtn = document.getElementById('dfl-empty-clear');
    var modeButtons = Array.prototype.slice.call(document.querySelectorAll('[data-dfl-mode]'));
    var availableBand = document.getElementById('dfl-available-band');
    var comingBand = document.getElementById('dfl-coming-band');
    var availableSub = document.getElementById('dfl-available-sub');
    var comingSub = document.getElementById('dfl-coming-sub');
    var comingGroupsEl = document.getElementById('dfl-coming-groups');

    var state = { query: '', mode: 'title', theme: 'all', availableOnly: false };

    // --- Build the Available band once (full cards). Filtering only toggles [hidden].
    var availableCardEls = availableBooks.map(function (book) {
      return { book: book, el: buildCard(book, freeLabel, suppressFreeFraming) };
    });
    availableCardEls.forEach(function (c) { availableGrid.appendChild(c.el); });
    availableSub.textContent = suppressFreeFraming
      ? availableBooks.length + ' ready now.'
      : availableBooks.length + ' ready now, including one free download.';

    // --- Build the Coming band once, grouped by theme, as compact rows.
    var comingRowEls = []; // { book, rowEl, groupEl }
    var comingGroupEls = {}; // subSeries name -> groupEl
    subSeriesOrder.forEach(function (name) {
      var inTheme = comingBooks.filter(function (b) { return b.subSeries === name; });
      if (!inTheme.length) return;
      var group = document.createElement('div');
      group.className = 'dfl-coming-group';
      group.setAttribute('data-theme', name);

      var h4 = document.createElement('h4');
      h4.className = 'dfl-coming-group__title';
      h4.textContent = name + ' ';
      var count = document.createElement('span');
      count.className = 'dfl-coming-group__count';
      count.textContent = '(' + inTheme.length + ')';
      h4.appendChild(count);
      group.appendChild(h4);

      var rows = document.createElement('ul');
      rows.className = 'dfl-coming-group__rows';
      inTheme.forEach(function (book) {
        var li = document.createElement('li');
        li.className = 'dfl-coming-row';
        li.setAttribute('data-key', book.key);
        var t = document.createElement('span');
        t.className = 'dfl-coming-row__title';
        t.textContent = book.title;
        var h = document.createElement('span');
        h.className = 'dfl-coming-row__hook';
        h.textContent = book.hook || '';
        var badge = document.createElement('span');
        badge.className = 'dfl-coming-row__badge';
        badge.textContent = comingLabel;
        li.appendChild(t);
        li.appendChild(h);
        li.appendChild(badge);
        rows.appendChild(li);
        comingRowEls.push({ book: book, el: li, groupEl: group });
      });
      group.appendChild(rows);
      comingGroupsEl.appendChild(group);
      comingGroupEls[name] = group;
    });
    comingSub.textContent = comingBooks.length + ' more titles, across ' + Object.keys(comingGroupEls).length + ' themes.';

    // --- Theme chips: prioritise themes that have something buyable today.
    var themesWithAvailable = subSeriesOrder.filter(function (name) {
      return availableBooks.some(function (b) { return b.subSeries === name; });
    });
    var themesWithoutAvailable = subSeriesOrder.filter(function (name) {
      return themesWithAvailable.indexOf(name) === -1;
    });

    function makeThemeChip(name) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'dfl-chip';
      btn.setAttribute('data-dfl-theme', name);
      btn.setAttribute('aria-pressed', 'false');
      btn.textContent = name;
      return btn;
    }

    var allChip = document.createElement('button');
    allChip.type = 'button';
    allChip.className = 'dfl-chip';
    allChip.setAttribute('data-dfl-theme', 'all');
    allChip.setAttribute('aria-pressed', 'true');
    allChip.textContent = 'All themes';
    primaryThemesEl.appendChild(allChip);
    themesWithAvailable.forEach(function (name) { primaryThemesEl.appendChild(makeThemeChip(name)); });

    var moreChip = document.createElement('button');
    moreChip.type = 'button';
    moreChip.className = 'dfl-chip dfl-chip--more';
    moreChip.setAttribute('aria-expanded', 'false');
    moreChip.setAttribute('aria-controls', 'dfl-themes-secondary');
    moreChip.textContent = 'More themes (' + themesWithoutAvailable.length + ')';
    primaryThemesEl.appendChild(moreChip);
    themesWithoutAvailable.forEach(function (name) { secondaryThemesEl.appendChild(makeThemeChip(name)); });

    moreChip.addEventListener('click', function () {
      var expanded = moreChip.getAttribute('aria-expanded') === 'true';
      moreChip.setAttribute('aria-expanded', expanded ? 'false' : 'true');
      secondaryThemesEl.hidden = expanded;
      moreChip.textContent = expanded
        ? 'More themes (' + themesWithoutAvailable.length + ')'
        : 'Fewer themes';
      if (!expanded) secondaryThemesEl.querySelector('[data-dfl-theme]').focus();
    });

    function normalize(str) {
      return (str || '')
        .toString()
        .toLowerCase()
        .normalize('NFKD')
        .replace(/[̀-ͯ]/g, '')
        .trim();
    }

    function matchesQuery(book) {
      if (!state.query) return true;
      var q = normalize(state.query);
      if (state.mode === 'theme') {
        return normalize(book.subSeries).indexOf(q) !== -1;
      }
      return (
        normalize(book.title).indexOf(q) !== -1 ||
        normalize(book.hook).indexOf(q) !== -1
      );
    }

    function matchesTheme(book) {
      return state.theme === 'all' || book.subSeries === state.theme;
    }

    function applyFilters() {
      // Available band
      var visibleAvailable = 0;
      availableCardEls.forEach(function (c) {
        var show = matchesQuery(c.book) && matchesTheme(c.book);
        c.el.hidden = !show;
        if (show) visibleAvailable += 1;
      });

      // Coming band (skipped entirely while "only what I can get today" is on)
      var visibleComing = 0;
      if (!state.availableOnly) {
        comingRowEls.forEach(function (r) {
          var show = matchesQuery(r.book) && matchesTheme(r.book);
          r.el.hidden = !show;
          if (show) visibleComing += 1;
        });
        Object.keys(comingGroupEls).forEach(function (name) {
          var group = comingGroupEls[name];
          var anyVisible = Array.prototype.some.call(group.querySelectorAll('.dfl-coming-row'), function (row) {
            return !row.hidden;
          });
          group.hidden = !anyVisible;
        });
      }

      comingBand.hidden = state.availableOnly || (visibleComing === 0 && (state.query || state.theme !== 'all'));
      availableBand.hidden = visibleAvailable === 0 && (state.query || state.theme !== 'all');

      // Plain-language, aria-live count, honest about both bands.
      var unfiltered = !state.query && state.theme === 'all';
      var parts = [];
      if (unfiltered) {
        parts.push(availableBooks.length + ' ready to get today');
        if (!state.availableOnly) parts.push(comingBooks.length + ' more on the way');
      } else {
        parts.push(visibleAvailable + ' of ' + availableBooks.length + ' ready today');
        if (!state.availableOnly) parts.push(visibleComing + ' of ' + comingBooks.length + ' on the way');
      }
      countEl.textContent = parts.join(' · ');

      var totalVisible = visibleAvailable + (state.availableOnly ? 0 : visibleComing);
      var noResults = totalVisible === 0 && (state.query || state.theme !== 'all');
      emptyEl.hidden = !noResults;
      if (noResults) {
        emptyQueryEl.textContent = state.query || state.theme;
      }

      clearBtn.hidden = !state.query;
    }

    searchInput.addEventListener('input', function () {
      state.query = searchInput.value;
      applyFilters();
    });

    clearBtn.addEventListener('click', function () {
      state.query = '';
      searchInput.value = '';
      searchInput.focus();
      applyFilters();
    });

    modeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.mode = btn.getAttribute('data-dfl-mode');
        modeButtons.forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        searchInput.placeholder =
          state.mode === 'theme' ? 'Search by theme, e.g. Water or Sound…' : `Search all ${(window.DFL_DATA || []).length} titles by name…`;
        applyFilters();
      });
    });

    function onThemeClick(event) {
      var btn = event.target.closest('[data-dfl-theme]');
      if (!btn) return;
      state.theme = btn.getAttribute('data-dfl-theme');
      document.querySelectorAll('[data-dfl-theme]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-dfl-theme') === state.theme ? 'true' : 'false');
      });
      applyFilters();
    }
    primaryThemesEl.addEventListener('click', onThemeClick);
    secondaryThemesEl.addEventListener('click', onThemeClick);

    availableToggle.addEventListener('click', function () {
      state.availableOnly = availableToggle.getAttribute('aria-pressed') !== 'true';
      availableToggle.setAttribute('aria-pressed', state.availableOnly ? 'true' : 'false');
      availableToggle.textContent = state.availableOnly ? 'Showing what I can get today' : 'Only show what I can get today';
      applyFilters();
    });

    emptyClearBtn.addEventListener('click', function () {
      state.query = '';
      state.theme = 'all';
      state.availableOnly = false;
      state.mode = 'title';
      searchInput.value = '';
      searchInput.placeholder = `Search all ${(window.DFL_DATA || []).length} titles by name…`;
      modeButtons.forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-dfl-mode') === 'title' ? 'true' : 'false');
      });
      document.querySelectorAll('[data-dfl-theme]').forEach(function (b) {
        b.setAttribute('aria-pressed', b.getAttribute('data-dfl-theme') === 'all' ? 'true' : 'false');
      });
      availableToggle.setAttribute('aria-pressed', 'false');
      availableToggle.textContent = 'Only show what I can get today';
      applyFilters();
      searchInput.focus();
    });

    applyFilters();
  }

  function buildCard(book, freeLabel, suppressFreeFraming) {
    // isFreeDisplay controls only how THIS card renders. suppressFreeFraming is page-scoped
    // (set from data-dfl-suppress-free on the shelf section), so it never touches book.state
    // or window.DFL_DATA - other pages rendering the same data keep the free framing.
    var isFreeDisplay = book.state === 'free' && !suppressFreeFraming;

    var li = document.createElement('li');
    li.className = 'dfl-card hub-card dfl-card--' + book.state;
    li.setAttribute('data-key', book.key);

    var a = document.createElement('a');
    a.className = 'dfl-card__cover-link';
    a.href = book.link;
    var img = document.createElement('img');
    img.src = book.cover;
    img.alt = book.title;
    img.loading = 'lazy';
    img.decoding = 'async';
    img.width = 500;
    img.height = 700;
    a.appendChild(img);
    if (isFreeDisplay) {
      var ribbon = document.createElement('span');
      ribbon.className = 'dfl-card__ribbon';
      ribbon.textContent = freeLabel;
      a.appendChild(ribbon);
    }
    li.appendChild(a);

    var body = document.createElement('div');
    body.className = 'dfl-card__body';

    var themeEl = document.createElement('p');
    themeEl.className = 'dfl-card__theme';
    themeEl.textContent = book.subSeries;
    body.appendChild(themeEl);

    var titleEl = document.createElement('h3');
    titleEl.className = 'dfl-card__title';
    titleEl.textContent = book.title;
    body.appendChild(titleEl);

    if (book.hook) {
      var hookEl = document.createElement('p');
      hookEl.className = 'dfl-card__hook';
      hookEl.textContent = book.hook;
      body.appendChild(hookEl);
    }

    var meta = document.createElement('div');
    meta.className = 'dfl-card__meta';
    if (isFreeDisplay) {
      var freeBadge = document.createElement('span');
      freeBadge.className = 'dfl-card__free';
      freeBadge.textContent = 'Free download';
      meta.appendChild(freeBadge);
    } else {
      var price = document.createElement('span');
      price.className = 'dfl-card__price';
      var cartIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      cartIcon.setAttribute('viewBox', '0 0 20 20');
      cartIcon.setAttribute('aria-hidden', 'true');
      cartIcon.innerHTML = '<path d="M2 3h2l1.6 9.6a1.5 1.5 0 0 0 1.48 1.25h6.24a1.5 1.5 0 0 0 1.48-1.25L16.5 6H5" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/><circle cx="8" cy="17" r="1" fill="currentColor"/><circle cx="14" cy="17" r="1" fill="currentColor"/>';
      price.appendChild(cartIcon);
      // book.price is null for the 'free' entry (Water Breaks the Rules) - it carries no price
      // in the shared data. Only this suppressed-display case needs a stand-in, matching the
      // other cards' format exactly.
      price.appendChild(document.createTextNode(book.price || '€ 9,95'));
      meta.appendChild(price);
    }
    body.appendChild(meta);

    var action = document.createElement('p');
    action.className = 'dfl-card__action';
    var link = document.createElement('a');
    link.className = 'hub-link';
    link.href = book.link;
    // Neutral CTA matching the other cards when free framing is suppressed on this page.
    // book.linkLabel itself is untouched (still "Get the free download" in the shared data),
    // so other pages rendering this same entry keep their own wording.
    link.textContent = isFreeDisplay ? book.linkLabel : (book.state === 'free' ? 'Get the booklet' : book.linkLabel);
    var arrow = document.createElement('span');
    arrow.className = 'hub-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '→';
    link.appendChild(document.createTextNode(' '));
    link.appendChild(arrow);
    action.appendChild(link);
    body.appendChild(action);

    li.appendChild(body);
    return li;
  }
})();
